import { render, staticRenderFns } from "./LienWalletModal.vue?vue&type=template&id=28c96a05&scoped=true&"
import script from "./LienWalletModal.vue?vue&type=script&lang=js&"
export * from "./LienWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./LienWalletModal.vue?vue&type=style&index=0&id=28c96a05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c96a05",
  null
  
)

export default component.exports